export const isDesign = (cv_obj) => !cv_obj?._data?.is_not_design && !cv_obj?._data?.clone_parent_cid;
